/**
 *
 * @param {*} 
 */
 import $message from './message'
 import store from '@/store/index'
 import $util from '@/utils/utils'
 import moment from 'moment'
 export default {
    detailpageURl(itemid,itemchildCompany,itemtype){
      return $util.getCurrentWebSiteByProduct()+`/company/detail/${itemid}/${itemchildCompany> 0 ? 1 : 0}/?type=${itemtype}`;
    },
    tradeURl(itemid){
      return $util.getCurrentWebSiteByProduct()+`/trade/detail/${itemid}`;
    },
    //滚动条的位置
    scrollLocation(scrollFatherCont,name,type){
      switch(name)
      {
      case '目标国家或地区位置':
        return scrollFatherCont.scrollTop= 0
      
      case '产品名称与行业类型':
        return scrollFatherCont.scrollTop= type=='company'?180:346
      
      case '采购商与供应商条件':
        return scrollFatherCont.scrollTop= type=='company'?440:691
       
      case '物流相关筛选条件':
        return  scrollFatherCont.scrollTop=type=='company'?1000:1187
       
      case '商品量价筛选条件':
        return scrollFatherCont.scrollTop=1300
      default:
        return scrollFatherCont.scrollTop=0
    }
    },
    //表格定位的位置
    locationHerf(){
      // this.$nextTick(() => {
      //   document.documentElement.scrollTop=this.$refs.intelligenceList.$el.querySelector('.maintable-body').offsetTop-30
      // })
    },
    // 下载
    downloadStream(data, fileName, ) {
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click();
      link.remove();
      // document.body.removeChild(DownloadLink);
     },
   // 下载excel等文件
    getBlob(url, name) {
      new Promise(resolve => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response)
          }
        }
        xhr.send()
      }).then(blob=>{
        let fileName = `${name}_${moment().format("YYYYMMDDHHmmss")}_${Math.ceil(Math.random()*1000)}`
        this.downloadStream(blob,`${fileName}.xlsx`); 
      }).catch(err=>{
        console.log(err);
      })
    },
    DownloadReport(res,fileName){
      const resData = res;
      var fileReader = new FileReader()
      if (resData.type === 'application/json') {
        const fileReader = new FileReader()
        fileReader.onload = () => {
          const jsonData = JSON.parse(fileReader.result)
           setTimeout(() => {
              $message({
              message:jsonData.msg,
              type: 'warning',
              duration: 2 * 1000
             });
             }, 300)
        }
        fileReader.readAsText(resData)
        store.commit('report_name','')
      } else {
       this.downloadStream(resData,fileName); 
       store.commit('report_name','')
      }
      return true
    },
    newDate(){
      var date = new Date()
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      var d = date.getDate()
      var t = date.getFullYear() - 1
      var l = date.getMonth() + 1
      var minute = date.getMinutes()
      var second = date.getSeconds()
      minute = minute < 10 ? '1' + minute : minute
      second = second < 10 ? '0' + second : second
      let redt = y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      let tedr = t + '-' + (l < 10 ? '0' + l : l) + '-' + (d < 10 ? '0' + d : d)
      return [tedr, redt]
    },
    newTime(){
      var date = new Date()
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      var d = date.getDate()
      var t = date.getFullYear() - 1
      var l = date.getMonth() + 1
      var minute = date.getMinutes()
      var second = date.getSeconds()
      minute = minute < 10 ? '1' + minute : minute
      second = second < 10 ? '0' + second : second
      let redt = y + '-' + (m < 10 ? '0' + m : m) 
      let tedr = t + '-' + (l < 10 ? '0' + l : l)
      return [tedr, redt]
    },
    Datatime(date1,date2,end1,end2){
      let oDate1 = new Date(date1);
      let oDate2 = new Date(date2);
      let starttime='';
      if( oDate2.getTime()>oDate1.getTime()){
         starttime=date2;
      }else if(oDate2.getTime()<=oDate1.getTime()) {
         starttime=date1;
      } 
      let Endtime1 = new Date(end1);
      let Endtime2 = new Date(end2);
      let datetime ='';
      if(Endtime1.getTime()<Endtime2.getTime()){
         datetime=end1;
      }else if(Endtime1.getTime()>=Endtime2.getTime()) {
         datetime=end2;
      };
      if( new Date(starttime).getTime()>new Date(datetime).getTime()){
        starttime=date2;
      }
      // 如果开始时间和结束时间超过3年，则默认展示3年
      let three = moment(datetime).subtract(3, "years").format('YYYY-MM-DD')
      if(starttime < three) {
        starttime = three
      }
      let data=[starttime,datetime];
      return data
    },
    Datatimeui(date1,date2,end1,end2){
      let oDate1 = new Date(date1);
      let oDate2 = new Date(date2);
      let starttime='';
      if( oDate2.getTime()>oDate1.getTime()){
        starttime=date2;
      };
      if(oDate2.getTime()<=oDate1.getTime()) {
        starttime=date1;
      };
      let Endtime1 = new Date(end1);
      let Endtime2 = new Date(end2);
      let datetime ='';
      if(Endtime1.getTime()<Endtime2.getTime()){
         datetime=end1;
      };
      if(Endtime1.getTime()>=Endtime2.getTime()) {
         datetime=end2;
      };
      let data=[starttime,datetime];
      return data
    },
    _calcMaxNumber(arr){
      let data=[];
      arr.forEach((item) => {
        data.push(item.value);
      })
      let max = Math.max(...data);
      let maxInt = Math.ceil(max/9.5);
      let maxVal = maxInt*10;
      return maxVal;
    },
    // 计算最小值
    _calcMinNumber(arr){
      let data=[];
      arr.forEach((item) => {
        data.push(item.value);
      })
      let min = Math.min(...data);
      let minInt = Math.floor(min/10);
      let minVal = minInt*10;
      return minVal;
    },
    calcMaxNumber(arr){
      let max = Math.max(...arr);
      let maxInt = Math.ceil(max/9.5);
      let maxVal = maxInt*10;
      return maxVal;
    },
    calcMinNumber(arr){
      let min = Math.min(...arr);
      let minInt = Math.floor(min/10);
      let minVal = minInt*10;
      return minVal;
    },
    //获取当前年月日  以及前三年的日期

    getCurrentData(){
      var date = new Date()
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      var d = date.getDate()
      var t = date.getFullYear() - 1
      var l = date.getMonth() + 1
      var minute = date.getMinutes()
      var second = date.getSeconds()
      minute = minute < 10 ? '1' + minute : minute
      second = second < 10 ? '0' + second : second
      let preTime = y-3 + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      let nextTime = y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      let dateRange=[]
      dateRange[0]=preTime  
      dateRange[1]=nextTime
      return dateRange
    },
  // 对查询关键字中的特殊字符进行编码
  encodeSearchKey(key) {
    const encodeArr = [{
      code: '%',
      encode: '%25'
    }, {
      code: '?',
      encode: '%3F'
    }, {
      code: '#',
      encode: '%23'
    }, {
      code: '&',
      encode: '%26'
    }, {
      code: '=',
      encode: '%3D'
    }];
    return key.replace(/[%?#&=]/g, ($, index, str) => {
      for (const k of encodeArr) {
        if (k.code === $) {
          return k.encode;
        }
      }
    });
  },
  //下载按钮权限
  btnDowloadPermission(serchKey){
    let data = JSON.parse(localStorage.getItem('gt6_getRules'))
    let isShow = data?(data.downloadRule[serchKey]==2?false:true):true //判断是否展示
    let isDisabled = data?(data.downloadRule[serchKey]==0?true:false):true//判断是否禁用
    let arr =[isShow,isDisabled]
    return arr
  },
  // 国家权限，需要隐藏的国家
  countryPermission(data){
    let rules = JSON.parse(window.localStorage.getItem('gt6_getRules'))
    let {extendRule} = rules || {}
    // home页面的权限
    let countrys = extendRule?.removeCountryIds
    // countrys = [131]
    if(countrys&&countrys.length) {
      return !(countrys.includes(data))
    } else {
      return true
    }
  },
 }
